module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "p01"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ct"
  }, [_vm._v("\n    !\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "pepiv"
  }, [_c('i', [_vm._v("Jesus is dead, Marx is dead, Elvis is dead")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("And I’m not feeling too good myself")])]), _vm._v(" "), _c('div', {
    staticClass: "peps"
  }, [_vm._v("\n    —A T-SHIRT IN SANTA MONICA\n  ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-743effc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/alex_9781571318060_oeb_p01_r1.vue
// module id = 72
// module chunks = 0